import { Controller } from "@hotwired/stimulus"
import { TurboNativeBridge } from "../turbo_native_bridge"

// This controller runs on uploads#index and transfers pending share
// data from iOS UserDefaults to the server. Once transferred, the
// server renders the UI - no client-side show/hide logic needed.
export default class extends Controller {
  connect() {
    if (!TurboNativeBridge.isNative) return
    this.uploadPendingShare()
  }

  async uploadPendingShare() {
    const pending = await TurboNativeBridge.getPendingShare()
    if (!pending || !pending.clientToken) return

    const body = new URLSearchParams({
      source_url: pending.sourceURL || "",
      client_token: pending.clientToken,
      share_type: pending.type || "url"
    })

    try {
      const response = await fetch("/pending_shares", {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
          "Accept": "text/vnd.turbo-stream.html"
        },
        body
      })

      if (response.ok) {
        // Server will handle UI via Turbo Stream response
        Turbo.renderStreamMessage(await response.text())
        // Clear local state only after successful transfer
        TurboNativeBridge.clearPendingShare()
      }
    } catch (error) {
      // Network error - keep local state for retry on next page load
      console.error("Failed to upload pending share:", error)
    }
  }
}
